/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { selectUser } from "../../../../../app/modules/Auth/_redux/authRedux";
import { useSelector } from "react-redux";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const user = useSelector(selectUser);

  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };
  const dataMenu = user.usernav;
  const items = dataMenu.filter((item) => item.menu_mobile !== "Y");

  return (
    <>
      {/* Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/* Loop Menu Level 1 */}
        {items.map((menu) => {
          if (menu.childs.length === 0) {
            // Render don't have child
            return (
              <li
                className={`menu-item ${getMenuItemActive(
                  `${menu.url}`,
                  false
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to={menu.url}>
                  <span className="svg-icon menu-icon">
                    <img
                      style={{ width: "18px", height: "18px" }}
                      src={toAbsoluteUrl(`/media/svg/icons/${menu.icon}`)}
                    />
                  </span>
                  <span className="menu-text">
                    {menu.title.replace("amp;", "")}
                  </span>
                </NavLink>
              </li>
            );
          } else {
            // Render if have child
            return (
              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  `${menu.url}`,
                  true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to={menu.url}>
                  <span className="svg-icon menu-icon">
                    <img
                      style={{ width: "18px", height: "18px" }}
                      src={toAbsoluteUrl(`/media/svg/icons/${menu.icon}`)}
                    />
                  </span>
                  <span className="menu-text">
                    {menu.title.replace("amp;", "")}
                  </span>

                  <i className="menu-arrow" />
                </NavLink>
                <div className="menu-submenu ">
                  <ul className="menu-subnav">
                    <ul className="menu-subnav">
                      {/* Loop Menu Level 2 */}
                      {menu.childs.map((submenu) => {
                        return (
                          <li
                            className={`menu-item ${getMenuItemActive(
                              `${submenu.url}`
                            )}`}
                            aria-haspopup="true"
                          >
                            <NavLink className="menu-link" to={submenu.url}>
                              {/* <span className="svg-icon menu-icon">
                                <img
                                  style={{ width: "18px", height: "18px" }}
                                  src={toAbsoluteUrl(
                                    `/media/svg/icons/${submenu.icon}`
                                  )}
                                />
                              </span> */}

                              <span className="menu-text">
                                {submenu.title.replace("amp;", "")}
                              </span>
                            </NavLink>
                          </li>
                        );
                      })}
                    </ul>
                  </ul>
                </div>
              </li>
            );
          }
        })}
      </ul>
    </>
  );
}
